module.exports = __webpack_public_path__ + "static/blog18-e42d0d5bae3606541819cea6253f0956.png";